import React from 'react';
import PropTypes from 'prop-types';
import ReduxDrawer from 'containers/DrawerManager/ReduxDrawer';
import { EDIT_CREDIT_CARD } from '../constants';
import EditCreditCardForm from './EditCreditCardForm';

const EditCreditCardDrawer = ({
  drawerProps = {},
  formProps = {},
  drawerKey = EDIT_CREDIT_CARD,
}) => (
  <ReduxDrawer
    WrappedComponent={EditCreditCardForm}
    drawerKey={drawerKey}
    drawerProps={{
      noBackdrop: true,
      headerTitle: `${formProps.isNew ? 'Add' : 'Edit'} payment method`,
      showBackButton: true,
      ...drawerProps,
    }}
    props={formProps}
  />
);

EditCreditCardDrawer.propTypes = {
  drawerProps: PropTypes.object,
  formProps: PropTypes.object,
  drawerKey: PropTypes.string,
};

export default EditCreditCardDrawer;
